var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,7.16a2.84,2.84,0,0,0-.8-1.93L18.78,2.81a2.83,2.83,0,0,0-3.84,0L10.4,7.39A8.49,8.49,0,0,0,2.3,9.61a1.06,1.06,0,0,0,0,1.49c1.3,1.26,2.9,2.86,4.5,4.46L2.53,19.78a1,1,0,0,0,0,1.47,1,1,0,0,0,.73.31,1,1,0,0,0,.74-.3L8.28,17l2.18,2.2,2.36,2.38a1.06,1.06,0,0,0,1.48,0,8.38,8.38,0,0,0,2.27-7.88l4.67-4.58A2.71,2.71,0,0,0,22,7.16ZM13.5,19.34l-1.66-1.68c-2.14-2.15-5-5.06-7.26-7.26a6.44,6.44,0,0,1,5.42-1l4.46,4.43A6.37,6.37,0,0,1,13.5,19.34ZM19.77,7.68,15.44,12,12.1,8.66l4.31-4.32a.73.73,0,0,1,.9,0L19.72,6.7a.76.76,0,0,1,.19.52A.65.65,0,0,1,19.77,7.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7275febbd1bb5f1fd5895fc6a63462d9.svg";
export { ForwardRef as ReactComponent };